module.exports = __webpack_public_path__ + "h5/img/user_discount.9684b28e.png";